import React from 'react';
import '../styles/StaticPages.css';

export default function Privacy() {
  return (
    <div className="static-page">
      <div className="static-page-container">
        <h1>מדיניות פרטיות</h1>
        <p className="last-updated">עדכון אחרון: ינואר 2026</p>
        
        <section className="page-section">
          <h2>1. מבוא</h2>
          <p>
            ב-Punkontrol אנו מכבדים את הפרטיות שלכם ומחויבים להגן על המידע האישי שלכם.
            מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגנים על המידע שלכם.
          </p>
        </section>

        <section className="page-section">
          <h2>2. מידע שאנו אוספים</h2>
          <h3>מידע שאתם מספקים:</h3>
          <ul>
            <li>שם משתמש וכתובת אימייל</li>
            <li>תמונת פרופיל וביוגרפיה</li>
            <li>יצירות אמנות ופוסטים שאתם מעלים</li>
            <li>תגובות, לייקים ואינטראקציות</li>
          </ul>
          
          <h3>מידע שנאסף אוטומטית:</h3>
          <ul>
            <li>כתובת IP ומידע על המכשיר</li>
            <li>פעילות באתר ודפוסי שימוש</li>
            <li>עוגיות (Cookies) למטרות פונקציונליות</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>3. שימוש במידע</h2>
          <p>אנו משתמשים במידע שלכם כדי:</p>
          <ul>
            <li>לספק ולשפר את השירותים שלנו</li>
            <li>להתאים אישית את החוויה שלכם באתר</li>
            <li>לשלוח הודעות חשובות על השירות</li>
            <li>למנוע הונאות ולשמור על אבטחת האתר</li>
            <li>לנתח שימוש ולשפר את האתר</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>4. שיתוף מידע</h2>
          <p>
            אנו <strong>לא מוכרים</strong> את המידע האישי שלכם לצדדים שלישיים.
          </p>
          <p>אנו עשויים לשתף מידע במקרים הבאים:</p>
          <ul>
            <li>עם הסכמתכם המפורשת</li>
            <li>עם ספקי שירות שעוזרים לנו להפעיל את האתר (Firebase, אחסון ענן)</li>
            <li>כאשר נדרש על פי חוק או צו שיפוטי</li>
            <li>להגנה על הזכויות והבטיחות שלנו ושל משתמשים אחרים</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>5. אבטחת מידע</h2>
          <p>
            אנו נוקטים באמצעי אבטחה סבירים כדי להגן על המידע שלכם מפני גישה לא מורשית,
            שינוי, חשיפה או השמדה. אנו משתמשים בהצפנה, חומות אש וגישה מוגבלת למידע רגיש.
          </p>
        </section>

        <section className="page-section">
          <h2>6. הזכויות שלכם</h2>
          <p>יש לכם את הזכות:</p>
          <ul>
            <li>לגשת למידע האישי שלכם ולערוך אותו</li>
            <li>למחוק את החשבון והמידע שלכם</li>
            <li>להסיר את ההסכמה שלכם לשימוש במידע</li>
            <li>להוריד עותק של המידע שלכם</li>
            <li>להגיש תלונה לרשות הפיקוח על הגנת הפרטיות</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>7. עוגיות (Cookies)</h2>
          <p>
            אנו משתמשים בעוגיות כדי לשפר את החוויה שלכם באתר, לשמור על ההתחברות שלכם
            ולנתח שימוש באתר. אתם יכולים לנהל את העדפות העוגיות בהגדרות הדפדפן שלכם.
          </p>
        </section>

        <section className="page-section">
          <h2>8. שינויים במדיניות</h2>
          <p>
            אנו עשויים לעדכן את מדיניות הפרטיות מעת לעת. 
            שינויים משמעותיים יובאו לידיעתכם באמצעות הודעה באתר או במייל.
          </p>
        </section>

        <section className="page-section">
          <h2>9. יצירת קשר</h2>
          <p>
            לשאלות או חששות בנוגע לפרטיות שלכם, אנא צרו קשר דרך{' '}
            <a href="/contact">עמוד יצירת הקשר</a> או שלחו מייל ל-privacy@punkontrol.com
          </p>
        </section>
      </div>
    </div>
  );
}
